import { Stack, Text } from '@chakra-ui/react'

import Divider from '@/components/Worlds/UI/Divider'

export default function PostReplyCount({ countReplies }: { countReplies: number }): JSX.Element {
  return (
    <Stack direction="row" align="center" spacing="8px">
      <Text variant="supporting" fontWeight="bold" color="fg.subtle" whiteSpace="nowrap">
        {countReplies === 1 ? '1 Reply' : `${countReplies} Replies`}
      </Text>
      <Divider flex={1} />
    </Stack>
  )
}
